import React from "react";
import Grid from "@mui/material/Grid2"; 
import { Box, Typography, Card, CardContent } from "@mui/material";
import { PensionFundCoverage } from "../../../../interfaces/DTO/mislaka_xml_insurence_models";
import { PolicyOrAccount } from "../../../../interfaces/DTO/mislaka_xml_models";
import { formatCurrency, formatIsoDate, formatPercentage } from "../../../../utils/namesFormater";
import { formatYesNo } from "../../../../utils/pensionEnumFormatter";
import { formatSurvivorsWaiverType } from "../../../../utils/enumFormatter";

interface PensionFundCoverageMetadataProps {
  policy: PolicyOrAccount;
}

const PensionFundCoverageMetadata: React.FC<PensionFundCoverageMetadataProps> = ({ policy }) => {
  // שליפת כל הכיסויים הפנסיוניים מכל `insurence_coverages`
  const allPensionCoverages: PensionFundCoverage[] = policy.insurence_coverages?.flatMap(
    (coverage) => coverage.coverages || []
  ) || [];

  if (allPensionCoverages.length === 0) return null;
  const formatValue = (value: string | number | undefined, format?: (val: any) => string): string => {
    if (value === undefined || value === null) return "-";
    if (typeof value === "number" || typeof value === "string") return format ? format(value) : value.toString();
    return "-"; // ברירת מחדל
  };
  return (
    <Box>
      {allPensionCoverages.map((coverage, index) => (
        <Card key={index} sx={{ mb: 2, p: 2 }}>
          <CardContent>
            <Typography variant="h6" sx={{ mb: 2 }}>כיסוי פנסיוני {index + 1}</Typography>
            <Grid container spacing={2}>
              {[
                // { label: "עלות כיסוי נכות", value: coverage.disability_coverage_cost, format: formatCurrency },
                // { label: "עלות פנסיית שארים של נכה", value: coverage.disabled_survivor_pension_cost, format: formatCurrency },
                // { label: "עלות כיסוי שארים", value: coverage.survivors_coverage_cost, format: formatCurrency },
                { label: "שכר קובע לכיסוי נכות ושאירים", value: coverage.defining_salary, format: formatCurrency },
                { label: "סך פנסיית נכות", value: coverage.total_disability_pension, format: formatCurrency },
                { label: "סך פנסיית אלמן/ת עמית", value: coverage.widow_pension_amount, format: formatCurrency },
                { label: "סך קצבת יתום", value: coverage.orphan_pension_amount, format: formatCurrency },
                { label: "קצבת הורה נתמך", value: coverage.parent_support_pension_amount, format: formatCurrency },
                { label: "שיעור כיסוי נכות", value: coverage.disability_coverage_rate, format: formatPercentage },
               
                { label: "תאריך נכונות שכר", value: coverage.salary_relevant_date, format: formatIsoDate },
                { label: "גיל פרישה לפנסיית זקנה", value: coverage.retirement_age },
                { label: "סוג ויתור שארים", value: coverage.survivors_waiver_type,format:formatSurvivorsWaiverType },
                { label: "נכות מתפתחת", value: coverage.developing_disability,format:formatYesNo },
                { label: "ויתור על כיסוי ביטוחי לנכות (מעל גיל 60)", value: coverage.insurance_waiver,format:formatYesNo },
                { label: "שיעור כיסוי יתום", value: coverage.orphan_coverage_rate, format:formatPercentage  },
                { label: "שיעור כיסוי אלמן/ה", value: coverage.widow_coverage_rate, format:formatPercentage },
                { label: "שיעור כיסוי הורה נתמך", value: coverage.parent_support_coverage_rate, format:formatPercentage  },
                { label: "מספר חודשי חברות רצופים", value: coverage.consecutive_membership_months },
                { label: "מספר חודשי חברות מצטבר", value: coverage.cumulative_membership_months },
                { label: "מנת פנסיה צבורה", value: coverage.pension_unit },
                { label: "אחוז פנסיה צבורה", value: coverage.pension_percentage, format:formatPercentage  },
                { label: "תאריך תחילת חברות", value: coverage.membership_start_date,  format:formatIsoDate },
                { label: "תאריך ערך לנתונים", value: coverage.data_relevant_date, format:formatIsoDate },
                { label: "תאריך חתימה על ויתור שארים", value: coverage.waiver_signature_date, format:formatIsoDate },
                { label: "תאריך סיום ויתור שארים", value: coverage.waiver_end_date, format:formatIsoDate },
              ].map((item, i) => (
                item.value !== undefined && (
                  <React.Fragment key={i}>
                    <Grid size={{ xs: 6, md: 4 }}>
                      <Typography variant="body2" fontWeight="bold">{item.label}:</Typography>
                    </Grid>
                    <Grid size={{ xs: 6, md: 8 }}>
                    <Typography>{formatValue(item.value, item.format)}</Typography>
                    </Grid>
                  </React.Fragment>
                )
              ))}
            </Grid>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default PensionFundCoverageMetadata;